import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("elswitch_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("elswitch_token");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export function wsUrl(path) {
  const base = BACKEND_URL.replace(/^http/, "ws");
  const token = localStorage.getItem("elswitch_token");
  const sep = path.includes("?") ? "&" : "?";
  return `${base}/api${path}${token ? `${sep}token=${encodeURIComponent(token)}` : ""}`;
}
